import clsx from "clsx";

const getLineItemAttributes = ({
  product,
  variant,
  selectedKitItems,
  subscribeId,
  isLineItem = true,
}) => {
  const currentVariant = variant || product?.variants?.edges[0]?.node;
  let lineAttributes = [];

  if (product?.tags?.includes('oversized')) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_oversized',
        value: 'true',
      },
    ];
  }

  if (product?.tags?.includes('standard sample') || product?.tags?.includes('deluxe sample')) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_nosto_sample',
        value: 'true',
      },
    ];
  }

  const sizeType = product?.burnedOption
    ? 'burnedOption'
    : 'widthOption';

  const sizeAttribute = clsx(
    product?.sizeOption?.value,
    product[sizeType]?.value && '/',
    product[sizeType]?.value,
  );

  if (sizeAttribute){
    lineAttributes = [
        ...lineAttributes,
        {
          key: '_type',
          value: sizeAttribute,
        },
      ];
  }

  if (product.horizontalImage) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_horizontal_image',
        value: product.horizontalImage?.value,
      },
    ];
  }

  if (product.shortDescription) {
    lineAttributes = [
      ...lineAttributes,
      {
        key: '_short_description',
        value: isLineItem
          ? product.shortDescription.value
          : product.shortDescription,
      },
    ];
  }

  if (currentVariant?.compareAtPrice) {
    lineAttributes.push({
      key: '_compare_price',
      value: parseInt(variant?.compareAtPrice?.amount, 10) * 100,
    });
  }

  if (selectedKitItems?.length > 0) {
    selectedKitItems.forEach((item, i) => {
      lineAttributes.push({
        key: `CGS_SKU_${i}`,
        value: item.variants[0].sku,
      });
      lineAttributes.push({
        key: `CGS_UPC_${i}`,
        value: item.variants[0].barcode,
      });
      lineAttributes.push({
        key: `CGS_title_${i}`,
        value: item.title,
      });
      // used to list included items in checkout summary
      // index is incremented so it starts at 1 for the end user
      // THIS IS COMMENTED OUT FOR NOW UNTIL WE CAN PREFIX THE CGS ATTRIBUTES WITH "_"
      // lineAttributes.push({
      //   key: `item_${i + 1}`,
      //   value: item.title,
      // });
    });
  }

  if (subscribeId) {
    lineAttributes.push({
      key: `_subscription`,
      value:
        // eslint-disable-next-line max-len
        product?.sellingPlanGroups?.edges[0]?.node?.sellingPlans?.edges?.find(
          (s) => s?.node?.id === `gid://shopify/SellingPlan/${subscribeId}`,
        )?.node?.name,
    });
  }

  return lineAttributes;
};

export default getLineItemAttributes;
